// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__kJlEh","label":"Input_label__7H1CW","field":"Input_field__9norV"};